function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("polygon", {
    style: {
      fill: "#E1E6E9"
    },
    points: "91.457,0 15.61,75.847 15.61,468.293 359.024,468.293 359.024,0 "
  }), React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M316.368,323.188c-7.674-8.763-18.889-14.841-31.567-17.115c-20.046-3.592-39.079-4.915-56.968-4.585 c-16.281-16.442-32.023-35.851-42.766-57.17c9.397-30.994,14.368-57.796,17.165-72.896c1.44-7.762-0.712-16.02-5.761-22.092 c-4.771-5.733-11.672-9.019-18.934-9.019c-0.006,0-0.011,0-0.017,0c-7.062,0.003-13.062,2.889-17.349,8.344 c-14.352,18.275-4.543,62.514-2.424,71.219c2.169,8.819,5.249,17.404,9.036,25.726c-7.451,23.488-17.499,48.996-31.1,73.129 c-45.396,16.556-72.442,39.307-74.661,41.22c-7.535,7.329-11.26,14.688-11.065,21.878c0.111,4.073,1.574,10.095,7.924,15.639 c4.865,4.243,11.088,6.364,17.41,6.364c6.411,0,12.928-2.182,18.222-6.539c21.914-18.033,39.474-40.411,53.564-64.177 c21.091-7.184,46.063-12.859,74.166-14.204c20.212,19.57,40.358,34.509,52.992,43.18c13.418,9.208,31.35,8.013,42.655-2.825 C327.462,349.114,327.267,335.627,316.368,323.188z M82.66,384.101c-4.065,3.347-10.026,3.57-13.545,0.495 c-1.351-1.184-2.052-2.269-2.08-3.228c-0.022-0.787,0.339-3.77,5.505-8.816c0.378-0.32,17.338-14.585,46.964-28.364 C108.95,358.892,96.756,372.501,82.66,384.101z M173.608,159.206c0.879-1.118,1.841-1.813,3.926-1.813 c2.98,0,4.916,1.793,5.805,2.861c1.841,2.213,2.625,5.224,2.102,8.052v0.003c-2.046,11.021-5.288,28.52-10.643,49.311 c-0.156-0.601-0.311-1.201-0.462-1.804C169.899,197.57,166.74,167.949,173.608,159.206z M158.883,311.361 c7.49-15.083,13.746-30.349,18.984-45.115c8.113,13.126,17.699,25.378,27.775,36.533 C188.794,304.424,173.163,307.482,158.883,311.361z M305.058,346.942c-5.477,5.269-14.38,5.708-21.158,1.062 c-9.308-6.389-22.932-16.359-37.511-29.112c11.388,0.531,23.204,1.81,35.398,3.995c8.88,1.59,16.598,5.694,21.736,11.555 C310.168,342.035,307.216,344.871,305.058,346.942z"
  }), React.createElement("polygon", {
    style: {
      fill: "#EBF0F3"
    },
    points: "91.457,75.847 91.457,0 15.61,75.847 "
  }), React.createElement("path", {
    style: {
      fill: "#27A2DB"
    },
    d: "M440.195,128.496H277.854c-6.897,0-12.488-5.591-12.488-12.488V46.495 c0-6.897,5.591-12.488,12.488-12.488h162.341c6.897,0,12.488,5.591,12.488,12.488v69.513 C452.683,122.905,447.092,128.496,440.195,128.496z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M322.012,59.637c3.646,3.046,5.47,7.741,5.47,14.085s-1.86,10.988-5.585,13.936 c-3.72,2.948-9.427,4.421-17.116,4.421h-9.293v15.36h-8.841V55.064h17.982C312.573,55.064,318.366,56.588,322.012,59.637z  M315.756,81.253c1.774-1.875,2.659-4.622,2.659-8.244c0-3.619-1.122-6.18-3.372-7.68c-2.25-1.497-5.768-2.247-10.567-2.247h-8.988 v20.979h10.262C310.646,84.061,313.982,83.125,315.756,81.253z"
  }), React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M377.531,61.921c5.049,4.57,7.567,10.927,7.567,19.07c0,8.14-2.445,14.585-7.341,19.329 c-4.896,4.747-12.39,7.119-22.476,7.119h-17.384V55.064h17.982C365.268,55.064,372.488,57.351,377.531,61.921z M376.183,81.213 c0-11.988-6.866-17.982-20.604-17.982h-8.841v35.89h9.817c6.341,0,11.201-1.509,14.573-4.534 C374.5,91.567,376.183,87.11,376.183,81.213z"
  }), React.createElement("path", {
    style: {
      fill: "#EBF0F3"
    },
    d: "M405.329,63.308v14.384h23.226v8.168h-23.226v21.579h-8.841V55.064h34.915l-0.073,8.244H405.329z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.ce8f6bc6.svg";
export { ForwardRef as ReactComponent };